export default {
  mounted: function mounted() {
    var _this = this;
    this.screenHeight = window.innerHeight;
    window.onresize = function () {
      _this.screenHeight = window.innerHeight;
      _this.$forceUpdate();
    };
  },
  data: function data() {
    return {
      screenHeight: null
    };
  },
  destroyed: function destroyed() {
    window.onresize = null;
  }
};